module.exports = __webpack_public_path__ + "static/media/wrapped-homecard-en.49a7e3f8.jpg";